<template>
  <div class="handler-container">
    <div :class="[handlerClass, className]" @click="parentClick" ref="handler">
      <!-- <BaseIcon
        class="icon-handler"
        width="6"
        height="7"
        :nameIcon="nameIcon"
        pathIcon="icons-ganeral"
      />-->
      <div v-if="!rightHand" style="">
        <svg
          id="Group_5954"
          data-name="Group 5954"
          xmlns="http://www.w3.org/2000/svg"
          width="61"
          height="12"
          viewBox="0 0 61 12"
          class="handle-list"
          style="
            position: absolute;
            left: 50%;
            cursor: pointer;
            transform: translateX(-50%) rotate(180deg);
          "
        >
          <g
            id="Rectangle_2033"
            data-name="Rectangle 2033"
            transform="translate(12.568 6.5)"
            fill="#fff"
            stroke="var(--custom-color1)"
            stroke-width="1"
            opacity="0"
          >
            <rect width="46" height="4" stroke="none" />
            <rect x="0.5" y="0.5" width="45" height="3" fill="none" />
          </g>
          <g
            id="Group_5953"
            data-name="Group 5953"
            transform="translate(61) rotate(90)"
          >
            <path id="Path_3823" data-name="Path 3823" d="M0,0,12,5V56L0,61Z" />
            <g
              id="חץ_לקומבו"
              data-name="חץ לקומבו"
              transform="translate(4.165 32.613) rotate(-90)"
            >
              <g id="Group_23" data-name="Group 23">
                <path
                  id="Path_23"
                  data-name="Path 23"
                  d="M0,.022,2.654,2.907,5.329,0"
                  fill="none"
                  stroke="#fff"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-miterlimit="10"
                  stroke-width="0.989"
                />
              </g>
            </g>
          </g>
        </svg>
      </div>
      <div
        class="line-handd"
        v-if="rightHand"
        style="
          z-index: 4;
          right: 0;
          left: auto;
          position: absolute;
          top: calc(50% - 20px);
        "
      >
        <!-- <svg
          xmlns="http://www.w3.org/2000/svg"
          width="8"
          height="40"
          viewBox="0 0 11.971 61"
        >
          <g
            id="Group_6779"
            data-name="Group 6779"
            transform="translate(-808 -378)"
          >
            <g
              id="Group_3700"
              data-name="Group 3700"
              transform="translate(1033.971 846) rotate(180)"
            >
              <path
                id="Path_3823"
                data-name="Path 3823"
                d="M0,0,11.971,5V56L0,61Z"
                transform="translate(214 407)"
                fill="var(--custom-color1)"
              />
              <g
                id="חץ_לקומבו"
                data-name="חץ לקומבו"
                transform="translate(221.058 434.283) rotate(90)"
              >
                <g id="Group_23" data-name="Group 23">
                  <path
                    id="Path_23"
                    data-name="Path 23"
                    d="M0,.022,2.654,2.907,5.329,0"
                    transform="translate(0 0)"
                    fill="none"
                    stroke="#fff"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-miterlimit="10"
                    stroke-width="0.989"
                  />
                </g>
              </g>
            </g>
          </g>
        </svg> -->
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="61"
          viewBox="0 0 12 61"
        >
          <g
            id="Group_5954"
            data-name="Group 5954"
            transform="translate(0 61) rotate(-90)"
          >
            <g
              id="Rectangle_2033"
              data-name="Rectangle 2033"
              transform="translate(12.568 1.5)"
              fill="#fff"
              stroke="#707070"
              stroke-width="1"
              opacity="0"
            >
              <rect width="46" height="4" stroke="none" />
              <rect x="0.5" y="0.5" width="45" height="3" fill="none" />
            </g>
            <g
              id="Group_5953"
              data-name="Group 5953"
              transform="translate(0 12) rotate(-90)"
            >
              <path
                id="Path_3823"
                data-name="Path 3823"
                d="M0,61l12-5V5L0,0Z"
                fill="var(--custom-color1)"
              />
              <g
                id="חץ_לקומבו"
                data-name="חץ לקומבו"
                transform="translate(7.072 28.387) rotate(90)"
              >
                <g id="Group_23" data-name="Group 23">
                  <path
                    id="Path_23"
                    data-name="Path 23"
                    d="M0,2.885,2.654,0,5.329,2.907"
                    fill="none"
                    stroke="#fff"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-miterlimit="10"
                    stroke-width="0.989"
                  />
                </g>
              </g>
            </g>
          </g>
        </svg>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["className", "txt", "left", "rightHand"],
  data() {
    return {
      handlerClass: "handler",
    };
  },
  computed: {
    handlerStyle() {
      return "top:" + "";
    },
    nameIcon() {
      if (this.txt) return "arrow-general";
    },
  },
  methods: {
    parentClick() {
      this.$emit("click");
    },
  },

  watch: {
    left: function () {
      this.$refs.handler.style.left = this.left + "%";
    },
  },
};
</script>

<style lang="scss">
.sideRight .handler-container {
  height: 12px;
  background-color: #dbdbdb;
  &.top {
    transform: rotate(180deg);
  }
}

.mefo-container .handler-container {
  height: 70px;
  background-color: #dbdbdb;
  &.top {
    transform: rotate(180deg);
  }
}

.handler-container1 {
  &.right {
    // height: 20px;
    // width: 20px;
    // top: 50%;
    // transform: translateY(-50%) translateX(-10px);
  }
  .fhandler {
    width: 50px;
    height: 20px;
    background-color: lightgray;
  }

  &.top {
    // top: 0px;
    // border-top: 11px solid rgba(0, 0, 0, 0.08);
    // border-bottom: 0 !important;
    .handler {
      border-top: 11px solid rgba(0, 0, 0, 0.08);
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      height: 0;
      width: 31px;
      // position: absolute;
      left: 50%;
      transform: translateX(-50%);
      font-size: 12px;
      text-align: center;
      color: white;
      cursor: pointer;
      z-index: 1;
      top: 0;
      transition: 0.3s;
      .arrow-general {
        top: -10px;
        position: absolute;
        line-height: 10px;
      }
      &:hover {
        border-top: 11px solid rgba(0, 0, 0, 0.12);
      }
    }
    .icon-handler {
      left: calc(100% + 5px);
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      height: 7px;
      svg {
        position: absolute;
        bottom: 6px;
        right: 15px;
        transform: translateX(50%) rotate(-90deg);
        stroke: rgba(0, 0, 0, 0.2);
      }
    }
  }
  &.bottom {
    bottom: 0px;
    // background-image: url("/handler-bottom.svg");
    .handler {
      border-bottom: 11px solid rgba(0, 0, 0, 0.15);
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      height: 0;
      width: 31px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      font-size: 12px;
      text-align: center;
      color: white;
      cursor: pointer;
      z-index: 2;
      bottom: 0px;
      transition: 0.3s;
      color: var(--text-color2);
      height: 10px;
      .arrow-general {
        line-height: 10px;
        height: 11px;
        transform: rotate(180deg);
      }
      &:hover {
        border-bottom: 11px solid rgba(0, 0, 0, 0.12);
      }
    }
    .icon-handler {
      left: calc(100% + 5px);
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      height: 7px;
      svg {
        position: absolute;
        top: 6px;
        right: 15px;
        transform: translateX(50%) rotate(-90deg);
        stroke: rgba(0, 0, 0, 0.2);
      }
    }
  }
  &.right {
    .handler {
      // position: absolute;

      // transform: translateX(-5px) translateY(-50%);
      // top: 50%;
      .arrow-general {
        display: none;
        height: 15px;
        width: 10px;
        line-height: 15px;
        color: #fff;
        position: absolute;
        transform: rotate(-90deg);
        right: -11px;
        top: 12px;
      }
    }
  }
  &.right.active .handler .arrow-general {
    transform: rotate(90deg);
    top: 22px;
    right: -9px;
  }
  .handler.bottom:hover {
    border-bottom-color: darkgray;
  }
  .handler.top:hover {
    border-top-color: darkgray;
  }
  .right .icon-handler {
    left: calc(100% + 5px);
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    height: 7px;
    svg {
      position: absolute;
      top: 0;
      left: 0;
      stroke: #fff;
    }
  }
}
</style>
